import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Components from '../../../components';
import Client from '../../../services'

const headerMap = {
    "index": {label: "Sl.No.",},
    "_id": {label: "Id",},
    "username": {label: "Username", filter: true},
    "name": {label: "Name", filter: true},
    "address": {label: "Address", filter: true},
    "createdAt": {label: "Created At",}
}



const StudentList = ({...props}) => {
    
    var [list, setList] = useState([])
    // Component Did mount
    useEffect(async()=>{
        const {success, data} = await Client.api.get('/management/student/list')
        if(success){
            const newList = data.map((user, i) => {
                return {
                    ...user,
                    index: i,
                    username: user.username ?
                    <Link to={`/management/student/details/${user._id}`}>
                        {user.username} 
                    </Link>
                    : 
                        <div>
                            <Components.buttons.FlatButton onClick={
                                async(e) => {
                                    e.preventDefault();
                                    const username = prompt("Enter username")
                                    if(username){
                                        const payload = {
                                            studentId : user._id,
                                            username
                                        }
                                        const {success} = await Client.api.put(`/management/student/${user._id}/username`, payload)
                                        if(success){
                                            setList(oldList => {
                                                oldList[i].username = username
                                                return [...oldList]
                                            })
                                        }
                                    }
                                }
                            }>Create</Components.buttons.FlatButton>
                        </div>
                }
            })
            setList(newList)
        }else{
            setList([])
        }
    },[])

    const headers = ["index", "username", "name", "address", "createdAt"]


    return <div className="student-list">
        <h2>Student List</h2>

        <ul>
            <li><Link to="/management/student/register">Register Student</Link></li>
        </ul>
        <Components.data.Table headerMap={headerMap} headers={headers} data={list} showFilters/>
    </div>
}

export default StudentList